<template>
  <div class="newBag-wrapper">
    <div class="forecast">
      <Title-b :title="$t('Forecastpackage.ForecastexpressbillNo')" />
      <div class="explain">
        <div class="e-tips">
          {{ $t("Forecastpackage.Shoppingwebsite") }}
        </div>
        <div class="explain-title">{{ $t("Forecastpackage.Descriptiontype") }}</div>
        <div class="type-list-wrapper">
          <div class="type-item" v-for="(item, index) in GoodList" :key="index">
            <div class="type-name">{{ item.GoodsName }}：</div>
            <div class="type-value">
              {{ item.goodsType }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-bag">
      <Tabs active-key="key2">
        <Tab-pane :label="$t('Forecastpackage.Singleforecast')" key="key1">
          <i-table
            :columns="columns"
            border
            :data="data"
            align="center"
            v-if="showTable"
            id="Tbaleone"
          ></i-table>
          <div class="btn-wrapper">
            <Button-b :value="$t('Home.Submit')" @click.native="verifyBag" class="m-r" />
            <Button-b :value="$t('Forecastpackage.Reset')" @click.native="init" />
          </div>
        </Tab-pane>
        <Tab-pane :label="$t('Forecastpackage.Batchforecast')" key="key2">
          <div class="from-content">
            <i-form
              ref="formRef"
              :model="formInline"
              :rules="ruleInline"
              label-position="right"
              :label-width="100"
              inline
            >
              <Form-item :label="$t('Forecastpackage.couriernumber')" prop="kdBillcode">
                <Input
                  v-model="formInline.kdBillcode"
                  type="textarea"
                  :autosize="{ minRows: 5, maxRows: 8 }"
                  :placeholder="$t('Forecastpackage.sdaasd')"
                  style="width: 310px"
                />
              </Form-item>
              <Form-item :label="$t('Forecastpackage.Namegoods')">
                <Input
                  v-model="formInline.Goods"
                  placeholder="請輸入品名(選填)"
                  style="width: 310px"
                />
                <!-- prop="Goods" prop="Goods"-->
                <!-- <Select v-model="GoosMoaol" filterable multiple style="width: 310px">
                  <Option v-for="(item, idx) in goodsName" :key="idx" :value="item"
                    >{{ item }}
                  </Option>
                </Select> -->
              </Form-item>
              <Form-item label="貨物價值">
                <Input
                  v-model="formInline.GoodsValue"
                  placeholder="請輸入貨物價值"
                  style="width: 310px"
                />
              </Form-item>
              <Form-item :label="$t('Forecastpackage.Typeofgoods')" prop="Goodsid">
                <i-select
                  v-model="formInline.Goodsid"
                  :label-in-value="true"
                  style="width: 310px"
                  :placeholder="$t('Forecastpackage.Pleasegoods')"
                  @on-change="changeSelect"
                >
                  <i-option
                    :value="item.GoodsID"
                    v-for="(item, index) in GoodList"
                    :key="index"
                    >{{ item.GoodsName }}</i-option
                  >
                </i-select>
              </Form-item>
              <!-- prop="Number" -->
              <!-- <Form-item :label="$t('Forecastpackage.Quantitygoods')">
                <Input
                  v-model="formInline.Number"
                  placeholder="請輸入貨物數量(選填)"
                  style="width: 310px"
                />
              </Form-item> -->
              <Form-item :label="$t('Forecastpackage.Remarks')">
                <Input v-model="formInline.Goods_meno" style="width: 310px" />
              </Form-item>
            </i-form>

            <div class="btn-wrapper">
              <Button-b
                :value="$t('Home.Submit')"
                @click.native="handleSubmit('formRef')"
                class="m-r"
              />
              <Button-b
                :value="$t('Forecastpackage.Reset')"
                @click.native="handleReset('formRef')"
              />
            </div>
          </div>
        </Tab-pane>
        <!-- <Tab-pane label="导入预报" key="key3">
          <i-button type="info">选择文件</i-button>
          <i-button type="info">导入</i-button>
          </Tab-pane> -->
        <!-- <Upload
            multiple
            ref="upload"
            :before-upload="handleUpload"
            :show-upload-list="false"
            :on-success="handleSuccess"
            action="http://39.99.246.93:8881/Website/uploadImg"
          >
            <Button icon="ios-cloud-upload-outline">选中文件</Button>
          </Upload> -->
      </Tabs>
      <!-- <div class="kkk">
        <div class="One">我的第一个div</div>
        <div class="Two"><button>我的第二个div  我在第一个div的上面</button></div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { colInput, colSelect, headerTop, colTop, colSelectName } from "./index.js";
export default {
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 60,
          align: "center",
        },
        {
          title: "快遞單號",
          key: "kdBillCode",
          align: "center",
          ...colInput(this, "kdBillCode"),
        },
        {
          title: "貨物品名（選填）",
          key: "Goods",
          align: "center",
          ...colInput(this, "Goods"),
        },
        {
          title: "貨物類型",
          key: "Goodsid",
          align: "center",
          ...colSelect(this),
        },
        // {
        //   title: "貨物數量（選填）",
        //   key: "Number",
        //   align: "center",
        //   ...colInput(this, "Number"),
        // },
        {
          title: "貨物價值",
          key: "GoodsValue",
          align: "center",
          ...colInput(this, "GoodsValue"),
        },
        {
          title: "備註說明（選填）",
          key: "Goods_meno",
          align: "center",
          ...colInput(this, "Goods_meno"),
        },
        {
          title: "",
          key: "c",
          align: "center",
          ...headerTop(this),
          ...colTop(this),
        },
      ],
      //这个
      data: [
        {
          kdBillCode: "",
          Goods: "",
          Goodsid:"",
          Number: "",
          Goods_meno: "",
          GoodsType: "",
          MemberID: localStorage.getItem("userID"),
        },
      ],
      goodsName: [
        "衣服",
        "鞋子",
        "包包",
        "家居用品",
        "家具",
        "食品",
        "化妝品",
        "汽車用品",
        "個人護理產品",
        "文具",
        "植物",
        "廚房用品",
        "裝修建材",
        "電子產品",
        "其他",
      ],
      formInline: {
        kdBillcode: "",
        Goods: "",
        Goodsid: "",
        GoodsType: "",
        Goods_meno: "",
        Number: "",
        MemberID: localStorage.getItem("userID"),
        GoodsValue: "",
        // Immediatrly: 0,
        // GoodsValue: "",
      },
      ruleInline: {
        kdBillcode: [
          { required: true, message: "快递单号不能为空！", trigger: "change" },
        ],
          GoodsValue: [
          { required: true, message: "貨物價值不能为空！", trigger: "change" },
        ],
        // Goods: [{ required: true, message: "品名不能为空！", trigger: "change" }],
        Goodsid: [
          {
            required: true,
            message: "请选择货物类型",
            trigger: "change",
            type: "number",
          },
        ],
        // Number: [{ required: true, message: "货物数量不能为空", trigger: "change" }],
      },
      GoodList: [],
      showTable: true,
      idArr: [],
      tipObj: {},
      GoosMoaol: [],
    };
  },
  methods: {
    async queryGoods() {
      const JsonData = {
        MemberId: localStorage.getItem("userID"),
      };
      const { data } = await this.$post("QueryGoods", JsonData);
      if (data.State) {
        this.GoodList = JSON.parse(data.ReturnJson);
      }
    },

    async prediction(item, bol) {
      const { data } = await this.$post("SubBillCode", item);
      if (data.State) {
        return true;
      } else {
        this.$Message.error(`单号${bol ? "" : this.tipObj.kdBillCode} :${data.MsgText}`);
      }
    },

    verifyBag() {
      let bol = false;
      this.data.forEach((item) => {
        console.log(item)
        // 改了这里
        bol = Object.keys(item).some((key) => {
          return item["kdBillCode"] == "" || item["Goodsid"] == "" || item["Goods"] == "" || item["GoodsType" == "" ] || item["GoodsValue"] == "";
        });
      });
      
      if (bol) {
        this.$Message.error("请将内容填写完整!");
        return false;
      }
      this.promisFn(this.data);
      this.$router.push("./myBag");
    },
    promisFn(arr, bol) {
      let promiseList = [];
      let _this = this;
      arr.forEach((item) => {
        let fn = new Promise((resolve, reject) => {
          this.tipObj = item;
          if (item.Goods != "") {
            // item.Goods = bol ? item.Goods : item.Goods.join(",");
          } else {
            item.Goods = item.Goods == "" ? "無" : item.Goods;
          }
          item.Number = item.Number * 1;
          _this.prediction(item, bol).then(function (res) {
            resolve(res);
          });
        });
        promiseList.push(fn);
      });
      Promise.all(promiseList)
        .then((result) => {
          let leng = result.filter((item) => {
            return item;
          }).length;
          this.$Message.success(`提交成功：${leng}个!`);
          this.$router.push(`./myBag`);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeSelect(e) {
      this.formInline["GoodsType"] = e && e.label;
      
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        this.formInline.Number = this.formInline.Number * 1;
        // this.formInline.Goods = this.GoosMoaol
        // this.formInline.Goods = this.GoosMoaol.join(",");
        console.log(this.formInline.Goods,"货物品名")
        if (this.formInline.Goods == "") {
          this.$Message.error("货物品名不能为空");
          return false;
        }
         if (this.formInline.GoodsValue == "") {
          this.$Message.error("货物价值不能为空");
          return false;
        }
        if (valid) {
          let str = this.formInline["kdBillcode"];
          let arr = [];
          this.idArr = str.split(/[\n,]/g);
          this.idArr.forEach((item) => {
            let obj = {};
            obj = { ...this.formInline };
            if (item != "") {
              obj.kdBillcode = item;
              arr.push(obj);
            }
          });
          await this.promisFn(arr, true);
        } else {
          this.$Message.error("请将内容填写完整!");
        }
      });
    },
    init() {
      this.data = [
        {
          kdBillCode: "",
          Goods: "",
          Goodsid: "",
          Number: "",
          Goods_meno: "",
          GoodsType: "",
          MemberID: localStorage.getItem("userID"),
        },
      ];
      this.showTable = false;
      this.showTable = true;
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
  },
  created() {
    this.queryGoods();
  },
};
</script>
<style lang="scss" scoped>
.kkk {
  // background-color: red;
  position: relative;
  .One {
    background-color: #000;
    height: 60px;
    opacity: 0.2;
  }
  .Two {
    position: absolute;
    top: 0;
    left: 100px;
  }
}
/deep/.ivu-table-column-center {
  button {
    color: #000;
  }
  .ivu-btn > span {
    color: #000 !important;
  }
}
/deep/ #Tbaleone {
  color: #fff;
  .ivu-btn-primary {
    color: #fff;
  }
}
.newBag-wrapper {
  width: 100%;
  .forecast {
    background: #fff;
    border-radius: 5px;
    padding: 20px;
    .explain {
      padding-left: 40px;
      .e-tips {
        line-height: 2.5;
        text-indent: 1.5em;
        height: 30px;
        margin-top: 13px;
        font-size: 12px;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
        @include backgroundColor($_color);
      }
      .explain-title {
        margin: 14px 0;
        line-height: 1;
        color: #666;
        font-size: 14px;
        font-weight: bold;
      }
      .type-list-wrapper {
        width: 100%;
        padding: 10px 20px;
        background: #efefef;
        border-radius: 6px;
        .type-item {
          margin-bottom: 10px;
          line-height: 1;
          display: flex;
          flex-direction: row;
          .type-name {
            @include color($_color);
            font-size: 10px;
          }
          .type-value {
            color: #999999;
            font-size: 10px;
          }
        }
      }
    }
  }
  .table-bag {
    background: #fff;
    border-radius: 6px;
    margin-top: 10px;
    padding: 20px 60px;
    min-height: 532px;
    overflow: hidden;

    .btn-wrapper {
      display: flex;
      justify-content: center;
      margin-top: 40px;
      .button-custom {
        width: 200px;
      }
      .m-r {
        margin-right: 60px;
      }
    }
    .from-content {
      width: 420px;
      margin: 0 auto;
      .btn-wrapper {
        display: flex;
        justify-content: center;
        margin-top: 0;

        .m-r {
          margin-right: 60px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/view/homeManage/newBag.vue